import {ReactComponent as Equity} from '../Assets/CommonTenant/equity.svg'
import {ReactComponent as Corporate} from '../Assets/CommonTenant/corporate.svg'
import {ReactComponent as Government} from '../Assets/CommonTenant/government.svg'
import {ReactComponent as Value} from '../Assets/CommonTenant/value.svg'
import {ReactComponent as Wallet} from '../Assets/CommonTenant/wallet-send.svg'



export const logoBaseURL = 'https://logo.ignosis.ai/';
export const isLogEnabled =
  process.env.REACT_APP_CONSOLE_LOGS_ENABLED === 'true';
export const prefix = process.env.REACT_APP_PREFIX;

/**
 * Date Format Constants
 * Used across the application for consistent date formatting
 */
export const DATE_FORMATS = {
  /** Format: YYYY-MM-DD (e.g., 2025-02-14) - Used for API requests */
  YYYY_MM_DD: 'YYYY-MM-DD',
  /** Format: DD-MM-YYYY (e.g., 14-02-2025) - EPF date format */
  DD_MM_YYYY: 'DD-MM-YYYY',
  /** Format: DD/MM/YYYY (e.g., 14/02/2025) - Display format */
  DD_MM_YYYY_SLASH: 'DD/MM/YYYY',
  /** Format: MMYYYY (e.g., 022025) - EPF wage month format */
  MMYYYY: 'MMYYYY',
  /** Format: YYYYMM (e.g., 202502) - For sorting/comparison */
  YYYYMM: 'YYYYMM',
  /** Format: DD MMM YYYY (e.g., 14 Feb 2025) - Display format */
  DD_MMM_YYYY: 'DD MMM YYYY',
  /** Format: DD MMM YYYY hh:mm A (e.g., 14 Feb 2025 03:14 PM) - Display format with time */
  DD_MMM_YYYY_TIME: 'DD MMM YYYY hh:mm A',
  /** Format: DD MMM 'YY, hh:mm a (e.g., 14 Feb '25, 10:30 am) - Display with time */
  DD_MMM_YY_TIME: "DD MMM 'YY, hh:mm a",
  /** Format: MMM YYYY (e.g., Feb 2025) - Month year display */
  MMM_YYYY: 'MMM YYYY',
  /** Format: MMM-YY (e.g., Feb-25) - Short month year */
  MMM_YY: 'MMM-YY',
  /** Format: DD MMM (e.g., 14 Feb) - Day month display */
  DD_MMM: 'DD MMM',
  /** Format: DD MMM 'YY (e.g., 14 Feb '25) - Short date display */
  DD_MMM_YY: "DD MMM 'YY",
  /** Format: D - Day number */
  D: 'D',
  /** Format: M - Month number */
  M: 'M',
  /** Format: Do MMMM YYYY (e.g., 14th February 2025) - Full date with ordinal */
  Do_MMMM_YYYY: 'Do MMMM YYYY',
} as const;

export enum PortfolioTyoe {
  Banks,
  MF,
  Stocks,
  Deposits,
}

export enum FlowType {
  STOCKS,
  BANKS,
  MUTUAL_FUNDS,
  TERM_DEPOSITS,
  NPS,
  INSURANCE,
}

export enum ConsentType {
  PFM_BANKS = 'PFM_BANKS',
  PFM_FD = 'PFM_FD',
  PFM_MF = 'PFM_MF',
  PFM_STOCKS = 'PFM_STOCKS',
  PFM_RD_FD = 'PFM_RD_FD',
  PFM_NPS = 'PFM_NPS',
  PFM_INSURANCE = 'PFM_INSURANCE',
}

export enum FipId {
  CAMS = 'CAMSRTAFIP',
  CDSL = 'CDSLFIP',
  KFINTECH_MF = 'kfinmf-fip',
  NSDL = 'fip@nsdl',
  MOCK_FIP = 'FIP-ID',
  MOCK_MF_CAMS = 'IGNOSIS_MF_CAMS_FIP_UAT',
  MOCK_DEPOSIT_1 = 'IGNOSIS_BANK_DEPOSIT_1_UAT',
  MOCK_DEPOSIT_2 = 'IGNOSIS_BANK_DEPOSIT_2_UAT',
  MOCK_PIRIMID = 'PIRIMID_FINTECH_BANK_FIP_UAT',
  YES_BANK = 'YES-BANK',
  NPS_PROD = 'NPS_PROD',
  KFINTECH_NPS = 'kfinnps-fip',
  CAMS_NPS = 'CAMSCRAFIP',
  MOCK_NPS = 'NPS_UAT',
}

export enum SdkFlowSelection {
  SHOW_FIP_SELECTION = 'SHOW_FIP_SELECTION',
}

/**
 * Banks that provide T-1 (previous day) transaction data
 * Used to determine date range filtering for transactions
 */
export const T_MINUS_ONE_BANKS = [
  'AXIS001',
  'BOM_FIP',
  'fiplive@canarabank',
  'fiplive@indusind',
  'HDFC-FIP',
  'IBFIP',
  'idbibank-fip',
  'KBL-FIP',
  'KotakMahindraBank-FIP',
  'kvgbank-fip',
  'PNB-FIP',
  'UCOB-FIP',
  'fiplive@fincarebank',
] as const;

export interface FIP {
  enabled?: string;
  id: string;
  name: string;
  altNames?: string[];
}
export enum DepositTab {
  ALL = 'All',
  ACTIVE = 'Active',
  MATURED = 'Matured',
}

export enum AccountType {
  BANK = 'bank',
  MUTUAL_FUND = 'mutualfund',
  STOCK = 'stock',
  DEPOSIT = 'deposit',
  NPS = 'nps',
}

export const NPS_CATEGORY = {
  E: 'Equity',
  C: 'Corporate debt',
  G: 'Government bonds',
  A: 'Alternative asset'  
}

export const NPS_ICON_MAPPING = {
  EQUITY: Equity,
  CORPORATE_DEBT: Corporate,
  GOVERNMENT_BONDS: Government,
  ALTERNATIVE_ASSET: Wallet,
  CURRENT_VALUE: Value
}
